module.exports = __webpack_public_path__ + "static/media/Deterra-Berserker.6e17bb15.png";